(() => {
  const forms = [...document.querySelectorAll('.fcp27-form')];
  const storageKey = form => 'fcp27-submit-' + form.id;
  forms.forEach(form => {
    try {
      if (form.querySelector('[data-fcp27-success]')) sessionStorage.removeItem(storageKey(form));
      if (form.querySelector('[data-fcp27-errors]')) {
        const saved = JSON.parse(sessionStorage.getItem(storageKey(form)) || 'null');
        if (saved && Date.now() - saved.time >= 900000) sessionStorage.removeItem(storageKey(form));
        if (saved && Date.now() - saved.time < 900000) {
          [...form.elements].forEach(field => {
            if (field.name === 'contact[プライバシー確認]') return;
            const item = saved.fields.find(item => item.name === field.name && item.value === field.value);
            const text = saved.fields.find(item => item.name === field.name);
            if (field.type === 'checkbox' || field.type === 'radio') field.checked = Boolean(item && item.checked);
            else if (text && field.type !== 'hidden') field.value = text.value;
          });
        }
      }
    } catch (_) { /* Browsers may disable session storage. Native validation still works. */ }
  });
  const topic = document.getElementById('inquiry-topic');
  if (topic) {
    const requestedTopic = new URLSearchParams(window.location.search).get('topic');
    const allowedTopics = ['coffee', 'machine', 'opening', 'oem', 'order', 'other'];
    if (!topic.value && allowedTopics.includes(requestedTopic)) topic.value = requestedTopic;
    const panels = document.querySelectorAll('[data-topic]');
    const prospectPanels = document.querySelectorAll('[data-prospect]');
    const volume = document.getElementById('coffee-volume');
    const product = document.getElementById('oem-product');
    function setPanel(panel, active) {
      panel.hidden = !active;
      panel.disabled = !active;
      if (!active) {
        panel.querySelectorAll('input,select,textarea').forEach(field => {
          if (field.type === 'checkbox' || field.type === 'radio') field.checked = false;
          else field.value = '';
        });
        panel.querySelectorAll('details').forEach(details => { details.open = false; });
      }
    }
    function showNested() {
      setPanel(document.getElementById('coffee-cups-panel'), topic.value === 'coffee' && volume.value === '');
      setPanel(document.getElementById('oem-blend-count'), topic.value === 'oem' && product.value === 'blend');
      setPanel(document.getElementById('oem-drip-count'), topic.value === 'oem' && product.value === 'drip');
    }
    function showTopic() {
      panels.forEach(panel => {
        setPanel(panel, panel.dataset.topic === topic.value);
      });
      const prospect = ['coffee', 'machine', 'opening', 'oem'].includes(topic.value);
      prospectPanels.forEach(panel => { setPanel(panel, prospect); });
      document.querySelector('[data-prospect-heading]').hidden = !prospect;
      showNested();
    }
    topic.addEventListener('change', showTopic);
    volume.addEventListener('change', showNested);
    product.addEventListener('change', showNested);
    showTopic();
  }
  document.querySelectorAll('.choice-group').forEach(group => {
    group.querySelectorAll('input[type="checkbox"]').forEach(field => {
      field.addEventListener('change', () => {
        if (!field.checked) return;
        group.querySelectorAll('input[type="checkbox"]').forEach(other => {
          if (other !== field && (field.hasAttribute('data-exclusive') || other.hasAttribute('data-exclusive'))) other.checked = false;
        });
      });
    });
  });
  forms.forEach(form => {
    const fields = form.querySelector('[data-form-fields]');
    const confirmation = form.querySelector('[data-confirm]');
    const list = form.querySelector('[data-confirm-list]');
    const review = form.querySelector('[data-fcp27-review]');
    if (!fields || !confirmation) return;
    form.noValidate = true;
    let confirmed = false;
    let submissionTimer;
    let submissionEvent = null;
    const send = form.querySelector('[data-fcp27-send]');
    const edit = form.querySelector('[data-edit]');
    const submissionStatus = document.createElement('p');
    submissionStatus.className = 'form-help';
    submissionStatus.setAttribute('role', 'status');
    confirmation.append(submissionStatus);
    function resetSubmission() {
      clearTimeout(submissionTimer);
      submissionEvent = null;
      send.disabled = !confirmed;
      edit.disabled = false;
      send.removeAttribute('aria-busy');
      send.textContent = 'この内容で送信する';
      submissionStatus.textContent = '';
    }
    window.addEventListener('pageshow', resetSubmission);
    form.addEventListener('submit', event => {
      if (confirmed) {
        if (submissionEvent && !submissionEvent.defaultPrevented) {
          event.preventDefault();
          return;
        }
        submissionEvent = event;
        try {
          sessionStorage.setItem(storageKey(form), JSON.stringify({time: Date.now(), fields: [...form.elements].filter(field => field.name.startsWith('contact[') && field.name !== 'contact[プライバシー確認]' && !field.matches(':disabled')).map(field => ({name: field.name, value: field.value, checked: field.checked}))}));
        } catch (_) { /* Sending does not depend on storage availability. */ }
        clearTimeout(submissionTimer);
        submissionStatus.textContent = '';
        setTimeout(() => {
          if (submissionEvent !== event) return;
          if (event.defaultPrevented) {
            resetSubmission();
            return;
          }
          send.disabled = true;
          edit.disabled = true;
          send.setAttribute('aria-busy', 'true');
          send.textContent = '送信を確認しています';
          submissionTimer = setTimeout(() => {
            resetSubmission();
            submissionStatus.textContent = '送信完了を確認できていません。入力内容は保持しています。通信環境をご確認ください。';
          }, 10000);
        }, 0);
        return; // Shopify owns submission and its normal spam protection.
      }
      event.preventDefault();
    });
    review.addEventListener('click', () => {
      if (!form.reportValidity()) return;
      list.replaceChildren();
      const answers = new Map();
      form.querySelectorAll('[data-label]').forEach(field => {
        if (field.matches(':disabled') || !field.value.trim()) return;
        if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
        const text = field.tagName === 'SELECT' ? field.options[field.selectedIndex].text : field.value.trim();
        answers.set(field.dataset.label, [...(answers.get(field.dataset.label) || []), text]);
      });
      answers.forEach((values, label) => {
        const term = document.createElement('dt');
        const value = document.createElement('dd');
        term.textContent = label;
        value.textContent = values.join(' / ');
        list.append(term, value);
      });
      form.querySelector('[data-fcp27-body]').value = [...answers].map(([label, values]) => label + ': ' + values.join(' / ')).join('\n');
      fields.hidden = true;
      confirmation.hidden = false;
      confirmation.focus();
      confirmed = true;
      form.querySelector('[data-fcp27-send]').disabled = false;
    });
    edit.addEventListener('click', () => {
      if (submissionEvent && !submissionEvent.defaultPrevented) return;
      resetSubmission();
      confirmed = false;
      form.querySelector('[data-fcp27-send]').disabled = true;
      confirmation.hidden = true;
      fields.hidden = false;
      fields.querySelector('input,select,textarea').focus();
    });
    fields.addEventListener('keydown', event => {
      if (!confirmed && !event.isComposing && event.key === 'Enter' && event.target instanceof HTMLInputElement && !['button', 'submit', 'reset', 'checkbox', 'radio'].includes(event.target.type)) {
        event.preventDefault();
        review.click();
      }
    });
    review.disabled = false;
  });
  const sample = document.querySelector('#sample-purchase, details.fq-sample');
  if (sample) {
    sample.id = 'sample-purchase';
    const openSample = () => { if (location.hash === '#sample-purchase') sample.open = true; };
    openSample();
    window.addEventListener('hashchange', openSample);
    document.querySelectorAll('[data-open-sample]').forEach(link => link.addEventListener('click', () => { sample.open = true; }));
  }
})();
